import type { IChartInfo } from '../../charts';
// eslint-disable-next-line no-duplicate-imports
import {
  area,
  column,
  pie,
  bar,
  rose,
  radar,
  scatter,
  //heatmap,
  gauge,
  funnel,
  markArea,
  markLine,
  markPoint,
} from '../../charts';

export const charts: IChartInfo[] = [
  area,
  column,
  pie,
  bar,
  rose,
  radar,
  scatter,
  //heatmap,
  gauge,
  funnel,
  markArea,
  markLine,
  markPoint,
];
